var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Deleted service accounts")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/admin/organizations/users/service-accounts/${_vm.tid}`,
                  expression:
                    "`/#/admin/organizations/users/service-accounts/${tid}`",
                },
              ],
              staticClass: "btn btn-link btn-sm",
              attrs: { type: "button" },
            },
            [
              _c("i", {
                staticClass: "fa fa-cog",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Active service accounts")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/admin/organizations/users/service-accounts/locked/${_vm.tid}`,
                  expression:
                    "`/#/admin/organizations/users/service-accounts/locked/${tid}`",
                },
              ],
              staticClass: "btn btn-link btn-sm",
              attrs: { type: "button" },
            },
            [
              _c("i", {
                staticClass: "fa fa-lock",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Locked service accounts")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("p", { staticClass: "text-muted" }, [
          _vm._v("Deleted service accounts that have been disabled."),
        ]),
        _vm._v(" "),
        _vm.deletedServiceAccounts.length
          ? _c("UsersTable", { attrs: { users: _vm.deletedServiceAccounts } })
          : _c("h4", [_vm._v("No deleted service accounts")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }